// Базовый URL бэкенда можно задавать через переменную окружения.
// По умолчанию используем относительный путь, чтобы фронтенд работал на локальном хосте рядом с API.
import { getAuthHeaders } from "./authService";
import { APP_API_BASE, DATA_API_BASE } from "./apiConfig";

export async function fetchStats(level, period = "all") {
  const res = await fetch(`${DATA_API_BASE}/stats/${level}?period=${period}`, { headers: { ...getAuthHeaders() } });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const json = await res.json();
  return json.data;
}



export async function fetchFullReport(level, id) {
  if (!level || !id) throw new Error("Level and ID are required");

  // Пример: /report/l1/41 или /report/sekce/F
  // encodeURIComponent нужен для ID типа "41.2" или сложных строк
  const url = `${DATA_API_BASE}/report/${level}/${encodeURIComponent(id)}`;

  const res = await fetch(url, { headers: { ...getAuthHeaders() } });

  if (!res.ok) {
    let errorMsg = `HTTP ${res.status}`;
    try {
      const errJson = await res.json();
      if (errJson.detail) errorMsg = errJson.detail;
    } catch (e) {}
    throw new Error(errorMsg);
  }

  return await res.json();
}

/**
 * Получает сводные данные для бенчмаркинга (сравнения отраслей).
 * @param {string} period - "all", "2021-2024", "2023-2024"
 * @param {string} level - "sekce", "l1", "l2"
 */
export async function fetchBenchmarks(period, level) {
  if (!period || !level) throw new Error("Period and Level are required");

  // Кодируем параметры для безопасности URL
  const p = encodeURIComponent(period);
  const l = encodeURIComponent(level);

  const url = `${DATA_API_BASE}/benchmarks/${p}/${l}`;

  const res = await fetch(url, { headers: { ...getAuthHeaders() } });

  if (!res.ok) {
    let errorMsg = `HTTP ${res.status}`;
    try {
      const errJson = await res.json();
      if (errJson.detail) errorMsg = errJson.detail;
    } catch (e) {}
    throw new Error(errorMsg);
  }

  // Возвращаем { meta: {...}, data: [...] }
  return await res.json();
}

/**
 * Получает иерархические данные CAGR (Drill-down).
 * * @param {string} parentLevel - Уровень, В КОТОРЫЙ мы проваливаемся: 'root' | 'sekce' | 'l1'
 * @param {string|null} parentId - ID родителя (напр. 'F', '41'). Не нужен для 'root'.
 * @param {number|null} windowYears - Опционально: фильтр по длине окна (напр. 8).
 */
export async function fetchCagrDrilldown(parentLevel, parentId = null, windowYears = null) {
  // Проверка обязательного параметра
  if (!parentLevel) throw new Error("parentLevel is required");

  // Формируем параметры запроса
  const params = new URLSearchParams();
  params.append("parent_level", parentLevel);

  if (parentId) {
    params.append("parent_id", parentId);
  }

  if (windowYears) {
    params.append("window_years", windowYears);
  }

  // API_BASE берется из вашего конфига (обычно в начале файла api.js)
  const url = `${DATA_API_BASE}/cagr/drilldown?${params.toString()}`;

  const res = await fetch(url, { headers: { ...getAuthHeaders() } });

  if (!res.ok) {
    let errorMsg = `HTTP ${res.status}`;
    try {
      const errJson = await res.json();
      if (errJson.detail) errorMsg = errJson.detail;
    } catch (e) {}
    throw new Error(errorMsg);
  }

  return await res.json();
}

export async function searchCompany(query, mode = "exact") {
  if (!query) throw new Error("Query is required");
  const params = new URLSearchParams();
  params.append("query", query);
  params.append("mode", mode);
  const url = `${DATA_API_BASE}/company/search?${params.toString()}`;
  const res = await fetch(url, { headers: { ...getAuthHeaders() } });
  if (!res.ok) {
    let errorMsg = `HTTP ${res.status}`;
    try {
      const errJson = await res.json();
      if (errJson.detail) errorMsg = errJson.detail;
    } catch (e) {}
    throw new Error(errorMsg);
  }
  return await res.json();
}

export async function fetchCompanyContext(ico, rawOborId = null) {
  if (!ico) throw new Error("ICO is required");
  const params = new URLSearchParams();
  params.append("ico", ico);
  if (rawOborId) {
    params.append("raw_obor_id", rawOborId);
  }
  const url = `${APP_API_BASE}/api/company/context?${params.toString()}`;
  const res = await fetch(url, { headers: { ...getAuthHeaders() } });
  if (!res.ok) {
    let errorMsg = `HTTP ${res.status}`;
    try {
      const errJson = await res.json();
      if (errJson.detail) errorMsg = errJson.detail;
    } catch (e) {}
    throw new Error(errorMsg);
  }
  return await res.json();
}

export async function fetchCompanySummary(ico, rawOborId = null) {
  if (!ico) throw new Error("ICO is required");
  const params = new URLSearchParams();
  params.append("ico", ico);
  if (rawOborId) {
    params.append("raw_obor_id", rawOborId);
  }
  const url = `${APP_API_BASE}/api/company/summary?${params.toString()}`;
  const res = await fetch(url, { headers: { ...getAuthHeaders() } });
  if (!res.ok) {
    let errorMsg = `HTTP ${res.status}`;
    try {
      const errJson = await res.json();
      if (errJson.detail) errorMsg = errJson.detail;
    } catch (e) {}
    throw new Error(errorMsg);
  }
  return await res.json();
}
